import { Component, model, output } from '@angular/core';
import { FormArray, FormControl, Validators } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { InviteAdminsCommand } from '../../../../infrastructure/shared/model/fss.api';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../../../infrastructure/shared/ui/button/button';
import { FieldComponent } from '../../../../infrastructure/shared/ui/field/field';
import { EmailInputComponent } from '../../../../infrastructure/shared/components/email-input/email-input';
import { FormControlPipe } from '../../../../infrastructure/shared/pipes/form-control.pipe';
import { Users01 } from '../../../../infrastructure/shared/icons/users-01/users-01';
import { XClose } from '../../../../infrastructure/shared/icons/x-close/x-close';

@Component({
  standalone: true,
  selector: 'app-invite-admins-dialog',
  imports: [
    Dialog,
    ButtonComponent,
    FieldComponent,
    EmailInputComponent,
    FormControlPipe,
    Users01,
    XClose,
  ],
  templateUrl: './invite-admins-dialog.html',
  styleUrl: './invite-admins-dialog.scss',
})
export class InviteAdminsDialog {
  isVisible = model.required<boolean>();
  submitted = output<InviteAdminsCommand>();

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  protected emails = new FormArray<FormControl<string | null>>([
    this._createEmailCtrl(),
  ]);

  protected addEmail(): void {
    this.emails.push(this._createEmailCtrl());
  }

  protected removeEmail(index: number): void {
    if (this.emails.length <= 1) return;
    this.emails.removeAt(index);
  }

  protected onSubmit(): void {
    this.emails.controls.forEach((c) => {
      c.setValue((c.value ?? '').trim(), { emitEvent: false });
    });

    this._applyDuplicateErrors();
    this.emails.markAllAsTouched();
    this.emails.updateValueAndValidity();

    if (this.emails.invalid) return;

    const values = this.emails.controls.map((c) => c.value as string);
    this.submitted.emit(new InviteAdminsCommand({ emails: values }));
  }

  protected onCancel(): void {
    this.isVisible.set(false);
  }

  private _createEmailCtrl(): FormControl<string | null> {
    return new FormControl<string | null>('', {
      validators: [Validators.required, Validators.email],
    });
  }

  private _applyDuplicateErrors(): void {
    const counts = new Map<string, number>();
    for (const c of this.emails.controls) {
      const v = (c.value ?? '').toLowerCase();
      if (!v) continue;
      counts.set(v, (counts.get(v) ?? 0) + 1);
    }

    for (const c of this.emails.controls) {
      const v = (c.value ?? '').toLowerCase();
      const errors = { ...(c.errors ?? {}) };
      if (v && (counts.get(v) ?? 0) > 1) {
        errors['duplicate'] = true;
      } else {
        delete errors['duplicate'];
      }
      c.setErrors(Object.keys(errors).length ? errors : null);
    }
  }
}
